import { render, staticRenderFns } from "./hotCity.vue?vue&type=template&id=1910de6f"
import script from "./hotCity.vue?vue&type=script&lang=js"
export * from "./hotCity.vue?vue&type=script&lang=js"
import style0 from "./hotCity.vue?vue&type=style&index=0&id=1910de6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports